import moment from "moment";
import { adherenceLevel } from "./constants";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";
// Assets
import AvatarGray from "../assets/icons/avatar_gray.svg";
import AvatarBlue from "../assets/icons/avatar_blue.svg";
import AvatarRed from "../assets/icons/avatar_red.svg";
import AvatarYellow from "../assets/icons/avatar_yellow.svg";
import AvatarGreen from "../assets/icons/avatar_green.svg";

export const getAge = (birthDateParam) => {
  const now = new Date();
  const birthDate = new Date(birthDateParam);
  const m = now.getMonth() - birthDate.getMonth();
  let age = now.getFullYear() - birthDate.getFullYear();
  if (m < 0 || (m === 0 && now.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const passwordValidation = (password) => {
  const regExp = /^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~€])/;
  return regExp.test(password);
};

export const isValidDate = (date) => {
  return moment(date, "DD/MM/YYYY", true).isValid();
};

export const isValidBirthdate = (date) => {
  const age = moment().diff(date, "years");
  const limitedAge = 120;

  if (!isValidDate(date) || age > limitedAge) return false;
  return true;
};

export const isValidTime = (time) => {
  return moment(time, "HH:mm", true).isValid();
};

export const parsedDate = (date) => {
  const day = date.split("/")[0];
  const month = Number(date.split("/")[1]) - 1;
  const year = date.split("/")[2];
  return new Date(year, month, day, 12, 0, 0);
};

export const isLessThanToday = (date) => {
  const [day, month, year] = date.split("/").map(Number);

  const currentDate = new Date(year, month - 1, day);

  let today = new Date();
  today.setHours(0, 0, 0, 0);

  return currentDate < today;
};

export const checkIfItIsTheCurrentWeek = (date) => {
  const initialWeekDate = moment(date, "DD-MM-YYYY");
  const finalWeekDate = moment(date, "DD-MM-YYYY").add(6, "days");
  const today = moment();
  return today.isSameOrAfter(initialWeekDate, "day") && today.isSameOrBefore(finalWeekDate, "day");
};

export const parseSecondsToMinutes = (seconds) => {
  return Number(seconds) / 60;
};

export const parseSecondsToSecondsMinutesHours = (seconds) => {
  if (seconds < 60) return `${Math.round(seconds)} s`;

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  if (minutes < 60) return `${minutes}:${String(remainingSeconds).padStart(2, "0")} min`;

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}:${String(remainingMinutes).padStart(2, "0")} h`;
};

export const getSecondsBetweenTwoDates = (date1, date2) => {
  return Math.abs(new Date(date1) - new Date(date2)) / 1000;
};

export const formatTimeDifference = (date1, date2) => {
  const diffInSeconds = getSecondsBetweenTwoDates(date1, date2);
  return parseSecondsToSecondsMinutesHours(diffInSeconds);
};

export const getTrainedMinutesAndSeconds = (trainedSeconds) => {
  const minutes = Math.floor(trainedSeconds / 60);
  const seconds = trainedSeconds - minutes * 60;
  return `${minutes}’ ${seconds}’’`;
};

export const HeightValidation = (height) => {
  const min = 100;
  const max = 230;
  return Number(height) >= min && Number(height) <= max;
};

export const filterDataByDate = (period, sessions) => {
  if (period === "ALL_MONTHS") return sessions;

  const periods = {
    WEEK: 7,
    MONTH: 30,
    THREE_MONTHS: 90,
  };
  let intervalDays = periods[period];
  const limitedDate = new Date(moment().subtract(intervalDays, "days").format("YYYY/MM/DD"));

  return sessions.filter((session) => {
    const recordingDate = new Date(moment(session.STARTING_DATE).format("YYYY/MM/DD"));
    return recordingDate >= limitedDate;
  });
};

export const renderAvatar = (isThereSomePrescription, isTherePrescriptionsAfter7Days, adherence) => {
  if (!isThereSomePrescription) return AvatarGray;
  if (!isTherePrescriptionsAfter7Days) return AvatarBlue;
  if (Number(adherence) < adherenceLevel.lowToMedium) return AvatarRed;
  if (Number(adherence) >= adherenceLevel.lowToMedium && Number(adherence) <= adherenceLevel.mediumToHigh) return AvatarYellow;
  if (Number(adherence) > adherenceLevel.mediumToHigh) return AvatarGreen;
};

export const importImages = (context) => {
  let images = {};
  context.keys().forEach((key) => (images[key] = context(key).default));
  return images;
};

const ReactTooltipStyled = styled(ReactTooltip)`
  max-width: 500px;
  border-radius: 5px !important;
  padding: 15px !important;
`;
export const renderToolTip = (id) => {
  return <ReactTooltipStyled id={id} place="top" type="dark" effect="solid" delayShow={100} delayHide={100} />;
};
